"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GaiaClientFactory = void 0;
var GaiaClientBuilder_1 = require("./GaiaClientBuilder");
var GaiaClientFactory = /** @class */ (function () {
    function GaiaClientFactory() {
    }
    GaiaClientFactory.prototype.http = function (url) {
        return GaiaClientBuilder_1.GaiaClientBuilder.http(url);
    };
    return GaiaClientFactory;
}());
exports.GaiaClientFactory = GaiaClientFactory;
//# sourceMappingURL=GaiaClientFactory.js.map